<form [formGroup]="form" (ngSubmit)="forgotPassword()" class="relative">

    <div *ngIf="!f.invalid && success" class="alert alert-success" role="alert">
        <a href="#" class="alert-link" lang>auth.reset-success</a>
    </div>

    <div *ngIf="error && !timeoutError" class="alert alert-danger" role="alert">
        <a class="alert-link"> {{errorMessage}} </a>
    </div>
    
    <div *ngIf="timeoutError && !error" class="alert alert-danger" role="alert">
        <a class="alert-link" lang>auth.error</a>
    </div>

    <!-- User -->
    <div class="form-group input-group">
        <input name="user" formControlName="user" class="form-control form-input" placeholder="{{ 'auth.reset-password-placeholder' | lang }}" type="user"
            [ngClass]="{ 'is-invalid': submitted && f.user.errors }">
    </div>

    <!-- Register button -->
    <div class="form-group">
        <button class="btn send" lang>auth.reset-password-button</button>
    </div>

    <!-- Spinner  -->
    <hs-spinner [show]="loading"></hs-spinner>



</form>